module.exports = __webpack_public_path__ + "static/img/lun_3.53a6431.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_3.jpg
// module id = tka+
// module chunks = 1